import ReactDOM from 'react-dom/client';
import App from './App';
import './index.scss';
import { createBrowserRouter, createHashRouter, RouterProvider } from 'react-router-dom';
import ErrorPage from './error-page';
import MacroRenderer from './modules/advance-html/components/macro/renderer/macro.renderer';
import { QueryClient } from '@tanstack/react-query';
import { TemplateFormView } from './modules/advance-html/components/admin/template/TemplateFormView';
import 'allotment/dist/style.css';
import { ForgeNavigator } from './forge.navigator';
import MacroConfigPopup from './modules/advance-html/components/macro/macro-config/macro.config.popup';
import TemplateList from './modules/advance-html/components/admin/template/TemplateList';
import { TemplateRenderer } from './modules/advance-html/components/admin/template/TemplateRenderer';
import AdminComponent from './modules/advance-html/components/admin/Admin';
import { TemplateConfiguration } from './modules/advance-html/components/macro/macro-config/TemplateConfiguration';

// setting monaco editor
// import { loader } from '@monaco-editor/react';
// import * as monaco from 'monaco-editor';
// loader.config({ monaco });

const defaultData = {
  borderRadius: 3,
  colorPrimary: '#1677ff'
};
const queryClient = new QueryClient();

const router = createHashRouter([
  {
    path: '/',
    element: <AdminComponent />,
    errorElement: <ErrorPage />
  },
  {
    path: '/admin-page',
    element: <AdminComponent />,
    errorElement: <ErrorPage />
  },
  {
    path: '/templates',
    element: <TemplateList />,
    errorElement: <ErrorPage />
  },
  {
    path: '/templates/:id/edit',
    element: <TemplateFormView />,
    errorElement: <ErrorPage />
  },
  {
    path: '/templates/:id/configure',
    element: <TemplateConfiguration />,
    errorElement: <ErrorPage />
  },
  {
    path: '/macro/render',
    element: <MacroRenderer />,
    errorElement: <ErrorPage />
  },
  {
    path: '/mock-macro/render/:id',
    element: <TemplateRenderer />,
    errorElement: <ErrorPage />
  },
  {
    path: '/macro/config',
    element: <MacroConfigPopup />,
    errorElement: <ErrorPage />
  },
  {
    path: '/error-page',
    element: <ErrorPage />,
    errorElement: <ErrorPage />
  },
  {
    path: '*',
    element: <AdminComponent />,
    errorElement: <ErrorPage />
  }
]);

ReactDOM.createRoot(document.getElementById('root')).render(
  <App>
    <RouterProvider router={router} />
  </App>
);
